import React from 'react';

var ErrorCircle = function ErrorCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm1.376-14.168c0 .048-.016.096-.016.144l-.896 5.808h-.928l-.896-5.808c0-.048-.016-.096-.016-.144 0-.72.72-1.152 1.376-1.152.656 0 1.376.432 1.376 1.152zm-.112 8.048c0 .704-.56 1.264-1.264 1.264s-1.264-.56-1.264-1.264.56-1.264 1.264-1.264 1.264.56 1.264 1.264z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

ErrorCircle.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ErrorCircle as icon };
export default iconHandler(ErrorCircle);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ErrorCircle.js
// module id = 597
// module chunks = 0